export const environment = {
	production: true,
	loginLogoLeftUrl: 'assets/images/Panda - Icon (Dark Background).png',
	loginLogoRightUrl: 'assets/images/logo1.jpg',
	loginImageLeftUrl: 'assets/images/hc-13b-main.png',
	loginImageRightUrl: 'assets/images/Panda Vertical Logo (1).png',

	ticketListShowMembershipColumn:true,
	ticketListShowTicketReferenceColumn:true,
	createMemberTicketWithoutCategory: false
};
